import { ISearchElementStyle } from './searchPageConfig';

// Admin-editor mirror of the shopper checkout-page config
// (ac-storefront-web: Components/Helpers/checkoutPageConfig.ts). Persisted as a single JSON string
// on IStorefrontSettings.checkoutPageConfig. Each section is a bag of CSS props (ISearchElementStyle)
// applied to a bounding component of the checkout (order) page. Absent config = zero inline styles (strictly additive).
export interface ICheckoutPageConfig {
    container?: ISearchElementStyle;
    title?: ISearchElementStyle;
    summaryBox?: ISearchElementStyle;
    // The container wrapping the shipping / billing / terms-and-conditions form column.
    formContainer?: ISearchElementStyle;
    totalRow?: ISearchElementStyle;
    sectionHeading?: ISearchElementStyle;
    placeOrderButton?: ISearchElementStyle;
    prerequisitesBox?: ISearchElementStyle;
    continueButton?: ISearchElementStyle;
}

export const CHECKOUT_PAGE_SECTIONS = [
    'container', 'title', 'summaryBox', 'formContainer', 'totalRow', 'sectionHeading',
    'placeOrderButton', 'prerequisitesBox', 'continueButton',
] as const;

export const DEFAULT_CHECKOUT_PAGE_CONFIG: ICheckoutPageConfig = {};

export function parseCheckoutPageConfig(raw?: string): ICheckoutPageConfig {
    if (!raw) return { ...DEFAULT_CHECKOUT_PAGE_CONFIG };
    try {
        return { ...DEFAULT_CHECKOUT_PAGE_CONFIG, ...(JSON.parse(raw) as ICheckoutPageConfig) };
    } catch {
        return { ...DEFAULT_CHECKOUT_PAGE_CONFIG };
    }
}

export function serializeCheckoutPageConfig(config: ICheckoutPageConfig): string {
    return JSON.stringify(config);
}
